import AppRoute from "models/AppRoute"

const RequestsRoute = new AppRoute({
    route: "/requests",
    navbar: true,
    authRequired: true,
})

export default RequestsRoute
